import React from "react";
import { useHits } from "react-instantsearch-hooks-web";
import { AlgoliaTalentCard } from "../../pages/app/MarketplacePage/AlgoliaTalentCard";

export const Hits = (props: { offer: any }) => {
  const { offer } = props;
  const { hits, sendEvent } = useHits();

  return (
    <div className="ais-Hits">
      <ol className="ais-Hits-list">
        {hits.map((hit) => (
          <li key={hit.objectID} className="ais-Hits-item">
            <AlgoliaTalentCard hitTalent={hit} sendEvent={sendEvent} offer={offer} />
          </li>
        ))}
      </ol>
    </div>
  );
};
